<template>
    <div class="text-left">
        <div class="form py-3 px-0">
            <h1 class="text-center" v-if="showTitle">Edit Profile</h1>
            <template v-if="!showConfirm">
                <form class="form-group" data-vv-scope="attr" @submit.prevent="submit">
                    <label class="label-max">Profile</label>

                    <label for="firstname" class="label-mini mt-0">First Name</label>
                    <input v-validate required name="First name" v-model="form.given_name" id="firstname"
                           :class="{'is-invalid': errors.has('attr.First name')}" class="form-control"
                           placeholder="First Name" autofocus/>
                    <small class="text-danger" v-if="errors.has('attr.First name')">{{errors.first('attr.First name')}}</small>

                    <label for="lastname" class="label-mini">Last Name</label>
                    <input v-validate required name="Last name" v-model="form.family_name" id="lastname"
                           :class="{'is-invalid': errors.has('attr.Last name')}" class="form-control"
                           placeholder="LastName"/>
                    <small class="text-danger" v-if="errors.has('attr.Last name')">{{errors.first('attr.Last name')}}</small>

                    <label for="email" class="label-mini">Email</label>
                    <input v-validate required name="Email" type="email" v-model="form.email"
                           :class="{'is-invalid': errors.has('attr.Email')}" class="form-control"
                           id="email" placeholder="Email"/>
                    <small class="text-danger" v-if="errors.has('attr.Email')">{{errors.first('attr.Email')}}</small>

                    <label for="phone_number" class="label-mini">Phone Number</label>
                    <input type="tel" v-validate="'min:19'" required name="Phone number" v-model="form.phone_number"
                           :class="{'is-invalid': errors.has('attr.Phone number')}" class="form-control"
                           id="phone_number" placeholder="Phone number" @input="phoneChanged"
                           v-mask="'+1 (###) ### - ####'"/>
                    <small class="text-danger" v-if="errors.has('attr.Phone number')">{{errors.first('attr.Phone number')}}</small>

                    <div class="mt-3" :class="'alert alert-' + attrMessage.type" v-if="attrMessage.show">
                        {{ attrMessage.message }}
                    </div>
                    <!--<div class="d-flex justify-content-around mt-3">-->
                    <!--<w-button class="px-4" type="button" @click="updateAttr" :inverse="true">Save</w-button>-->
                    <!--</div>-->
                </form>

                <form class="form-group" data-vv-scope="pass" @submit.prevent="submit">

                    <label class="label-max">Password</label>
                    <label for="old_password" class="label-mini mt-0">Enter existing password</label>
                    <input :type="!showPass ? 'password' : 'text'" v-validate="{ required: true, regex: '[\\S].{4,96}[\\S]' }"
                           :class="{'is-invalid': errors.has('pass.Old password')}" name="Old password" class="form-control"
                           v-model="old_password" id="old_password" placeholder="Old password"/>
                    <small class="text-danger" v-if="errors.has('pass.Old password')">{{errors.first('pass.Old password')}}</small>

                    <label for="new_password" class="label-mini">Enter new password</label>
                    <input :type="!showPass ? 'password' : 'text'" v-validate="{ required: true, regex: '[\\S].{4,96}[\\S]' }"
                           :class="{'is-invalid': errors.has('pass.New password')}" name="New password" class="form-control"
                           v-model="new_password" id="new_password" placeholder="New password" ref="new_password"/>
                    <small class="text-danger" v-if="errors.has('pass.New password')">{{errors.first('pass.New password')}}</small>

                    <label for="password_confirmation" class="label-mini">Confirm new password</label>
                    <input :type="!showPass ? 'password' : 'text'" v-validate="{ required: true, regex: '[\\S].{4,96}[\\S]' }"
                           :class="{'is-invalid': errors.has('pass.Password confirmation')}" name="Password confirmation" class="form-control"
                           v-model="password_confirmation" id="password_confirmation" placeholder="Confirm new password" data-vv-as="new password"/>
                    <small class="text-danger" v-if="errors.has('pass.Password confirmation')">{{errors.first('pass.Password confirmation')}}</small>

                    <div class="mt-3" :class="'alert alert-' + passMessage.type" v-if="passMessage.show">
                        {{ passMessage.message }}
                    </div>
                    <div class="text-left text-blue cursor-pointer mt-2" @click="showPass = !showPass">
                        <span v-if="!showPass"><fa icon="eye"></fa> Show</span>
                        <span v-if="showPass"><fa icon="eye-slash"></fa> Hide</span>
                    </div>
                </form>
                <div class="mt-3 d-flex justify-content-center">
                    <w-button type="button" :class="{floating: floatingButton}" @click.prevent="submit" :inverse="true" :disabled="!changed">
                        {{changed ? 'Save' : 'Saved'}}
                    </w-button>
                </div>
            </template>

            <div class="form-group" v-else>
                <label class="label-max" for="code">Code</label>
                <input id="code" type="text" class="form-control" v-model="code" placeholder="Code">
                <div :class="'alert alert-' + codeMessage.type" v-if="codeMessage.show">{{ codeMessage.message }}</div>
                <div class="text-center">
                    <w-button class="px-4 mt-3" :inverse="true" @click="confirm">Submit</w-button>
                </div>
            </div>
            <div class="form-group">
                <label>User ID</label>
                <div class="text-muted">{{user.username}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import Cookies from 'js-cookie'

export default {
    name: 'Profile',
    props: {
        user: {
            required: true
        },
        auth: {
            required: true
        },
        logger: {
            required: true
        },
        floatingButton: {
            default: false
        },
        changed: {
            default: false
        }
    },
    data () {
        return {
            form: {
                given_name: this.user.attributes.given_name,
                family_name: this.user.attributes.family_name,
                email: this.user.attributes.email,
                phone_number: this.user.attributes.phone_number ? '+1 ' + this.user.attributes.phone_number.slice(2) : '+1'
            },
            old_password: '',
            new_password: '',
            password_confirmation: '',
            dataClone: null,
            code: '',
            showConfirm: false,
            codeError: '',
            passMessage: {
                show: false,
                type: '',
                message: ''
            },
            attrMessage: {
                show: false,
                type: '',
                message: ''
            },
            codeMessage: {
                show: false,
                type: '',
                message: ''
            },
            showPass: false
        }
    },
    computed: {
        attributes () {
            const attr = this.user.attributes
            return {
                given_name: attr.given_name,
                family_name: attr.family_name,
                email: attr.email,
                phone_number: attr.phone_number ? '+1' + attr.phone_number.slice(3) : '+1'
            }
        },
        showTitle () {
            return parseInt(Cookies.get('mobile_app')) !== 1
        }
    },
    methods: {
        async submit (e) {
            const attrValid = await this.$validator.validateAll('attr')
            if (attrValid) {
                this.updateAttr()
                if (this.old_password || this.new_password || this.password_confirmation) {
                    const passValid = await this.$validator.validateAll('pass')
                    if (passValid) {
                        this.changePassword()
                    }
                }
            }
        },

        phoneChanged (e) {
            if (!e.target.value.startsWith('+1 ')) e.target.value = '+1 ' + this.form.phone_number.slice(3)
            if (e.target.value.length < 3) e.preventDefault()
        },

        updateAttr (evt) {
            let payload = { ...this.form }
            if (payload.email !== this.user.attributes.email) payload.email_verified = false
            payload.phone_number = '+' + payload.phone_number.match(/\d/g).join('')
            this.auth.updateUserAttributes(this.user, payload).then(() => {
                if (payload.email !== this.user.attributes.email) this.showConfirm = true
                this.$emit('updated')
            }).catch(err => {
                this.attrMessage.show = true
                this.attrMessage.type = 'danger'
                this.attrMessage.message = err.message
                if (this.logger) {
                    this.logger.error('update error', err)
                }
            })
        },

        changePassword () {
            this.passMessage = { show: false, type: '', message: '' }
            this.auth.changePassword(this.user, this.old_password, this.new_password).then(data => {
                if (data === 'SUCCESS') {
                    this.old_password = ''
                    this.new_password = ''
                    this.password_confirmation = ''
                }
                this.$validator.reset('pass')
            }).catch(err => {
                this.passMessage.show = true
                this.passMessage.type = 'danger'
                this.passMessage.message = err.message
                setTimeout(() => {
                    this.passMessage = { show: false, type: '', message: '' }
                }, 5000)
            })
        },

        confirm () {
            this.auth.verifyCurrentUserAttributeSubmit('email', this.code).then(data => {
                if (data === 'SUCCESS') {
                    this.showConfirm = false
                    this.auth.updateUserAttributes(this.user, { email_verified: true }).then(() => {
                        this.$emit('updated')
                    })
                }
            }).catch(err => {
                this.codeMessage.show = true
                this.codeMessage.type = 'danger'
                this.codeMessage.message = err.message
            })
        },

        makeChange () {
            this.$emit('update:changed', JSON.stringify({
                ...this.form,
                old_password: this.old_password,
                new_password: this.new_password,
                password_confirmation: this.password_confirmation
            }) !== JSON.stringify(this.dataClone))
        }
    },
    watch: {
        form: {
            deep: true,
            handler () {
                this.makeChange()
            }
        },
        old_password: {
            handler () {
                this.makeChange()
            }
        },
        new_password: {
            handler () {
                this.makeChange()
            }
        },
        password_confirmation: {
            handler () {
                this.makeChange()
            }
        }
    },
    mounted () {
        this.dataClone = {
            ...this.form,
            old_password: this.old_password,
            new_password: this.new_password,
            password_confirmation: this.password_confirmation
        }
        const errMess = 'Please enter at least 6 alphanumeric characters.'
        this.$validator.localize('en', {
            custom: {
                'Old password': { regex: errMess, required: errMess },
                'New password': { regex: errMess, required: errMess },
                'Password confirmation': { regex: errMess, required: errMess }
            }
        })
    }
}
</script>

<style scoped>
    h1 {
        font-size: 28px !important;
        font-weight: 500 !important;
        color: #1a3f65 !important;
    }

    input::placeholder {
        color: #C4CFD5;
    }

    .info {
        font-family: Nunito, sans-serif;
    }

    .info h3, h1 {
        color: #23B8DC;
    }

    .form-group label {
        color: #F7F7F7;
        font-weight: 600;
        font-family: Nunito, sans-serif;
        font-size: 22px;
    }

    .text-blue {
        color: #23B8DC;
    }

    .cursor-pointer {
        cursor: pointer;
    }

    .form-control {
        border-top: 0;
        border-right: 0;
        border-left: 0;
        border-radius: 0;
        padding-top: 0;
        padding-bottom: 0;
        height: 22px;
        padding-left: 13px;
        font-size: 16px;
        border-color: #C4CFD5;
        color: #1A3F65;
    }

    .form-control:focus {
        border-color: #23B8DC;
        box-shadow: 0 0.2rem 0 0 #23b8dc54;
    }

    .form-control.is-invalid:focus {
        box-shadow: 0 0.2rem 0 0 #dc354540;
    }

    label.label-mini {
        display: block;
        margin-left: 13px;
        font-size: 10px;
        color: #7B8C9F;
        margin-bottom: 0;
        margin-top: 19px;
    }

    label.label-max {
        margin-bottom: 7px;
    }

    small {
        font-size: 11px;
        padding-left: 13px;
    }

    button.floating {
        position: fixed;
        right: 100px;
        bottom: 40px;
        max-width: 200px;
        width: 25%;
    }

    .btn-primary.floating:disabled {
        color: #23B8DC;
        background-color: #FFF;
        border-color: #23B8DC;
        opacity: 1;
        transition: all 1s;
    }

    @media (max-width: 769px) {
        button.floating {
            width: 75%;
        }
    }
</style>
